import {combineReducers} from 'redux';
import eventMetadata from './eventMetadataReducer';
import eventResults from './eventResultsReducer';
import eventResultsFilters from './eventResultsFiltersReducer';
import eventSummarySearch from './eventSummarySearchReducer';
import individualResult from './individualResultReducer';
import media from './mediaReducer';
import modal from './modalReducer';
import print from './printReducer';
import search from './searchReducer';
import userPrefs from './userPrefsReducer';
import mapTracking from './mapTrackingReducer';

const rootReducer = combineReducers({
  eventMetadata,
  eventResults,
  eventResultsFilters,
  eventSummarySearch,
  individualResult,
  media,
  modal,
  print,
  search,
  userPrefs,
  mapTracking
});

export default rootReducer;
